import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Aperis subite en nokta silento <br/>
        En mia memoro antikva fabel’. <br/>
        Mi perdis ŝueton – malgrava evento! <br/>
        Neniu alportis ĝin, - aĥ, bagatel’!
      </p>

      <p class="poem-block mb-3">
        Mi longe atendis kaj ĉesis atendi, <br/>
        Ja estas pli gravaj aferoj en viv’. <br/>
        Kial do mi rajtas miraklon atendi? <br/>
        Ja ĉion atingas la  triv’.
      </p>

      <p class="poem-block mb-3">
        Kaj perdis mi ie l’ ŝueton alian, <br/>
        Ĝi kuŝas en polvo sur voja rand’, <br/>
        Sed mi ĝin ne serĉis – ne estis por kio, <br/>
        Ne maltrankviligis min tiu demand’.
      </p>

      <p class="poem-block mb-3">
        Homoj diversaj iras laŭ voj’: <br/>
        Bela reĝid’ kaj danĝera aĉul’. <br/>
        Eble, rabist’  ŝuon trovos sur voj’ <br/>
        Kaj nokte alportos al mia angul’.
      </p>

      <p class="poem-block mb-3">
        Domaĝe, se havus mi unu nur. <br/>
        Sed se mankas ambaŭ – do, aĥ, bagatel’, <br/>
        Facile mi pensas, ke – aĥ, bagatel’! <br/>
        Forgesos mi ĉion sen spur’.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Bagatelo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['oVQQULakxz4&start=336&end=411'],
    itemTranslator: translator.esp
  }
}

export default item;